var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
'header_unit',
 _vm.pageType === 'top' || 'manage' ? 'header_bg_white' : 'header_bg_blue'
 ]},[_c('div',{staticClass:"header_box"},[_c('div',{staticClass:"menu_left",staticStyle:{"z-index":"0"}},[_vm._t("menu_left")],2),_c('div',{staticClass:"menu_center",staticStyle:{"z-index":"1"}},[_vm._t("menu_center")],2),_c('div',{staticClass:"menu_help"},[_vm._t("menu_help")],2),_c('div',{staticClass:"menu_right"},[_vm._t("menu_right")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }